(function () {
    "use strict";

    angular.module("app.sales").controller("SalesPaymentController", SalesPaymentController);

    SalesPaymentController.$inject = [
        "$scope",
        "$timeout",
        "CartService",
        "GeneralService",
        "CustomerAddressService",
        "CustomerGeneralService",
        "SalesPaymentService",
    ];

    function SalesPaymentController(
        $scope,
        $timeout,
        CartService,
        GeneralService,
        CustomerAddressService,
        CustomerGeneralService,
        SalesPaymentService
    ) {
        var vm = this;
        vm.success = false;
        vm.newCustomerAddress = {};
        vm.newGuestCustomerAddress = {
            MessageStatus: true,
            AddressType: "INDIVIDUAL",
        };
        vm.frmUserAddressSave = {
            AddressType: "INDIVIDUAL",
        };
        vm.VendorLocation = {};
        vm.isAuthenticated = false;
        vm.pay = {
            CreditCardPaymentOption: "00",
            CardNumber: undefined,
        };
        vm.loading = false;
        vm.tabIndex = 0;
        vm.salesOrderType = "sales";
        vm.tabOneDisable = false;
        vm.tabTwoDisable = false;
        vm.accorionStatus = [];
        vm.accorionStatus["_creditcard"] = {
            open: true,
        };
        var fastBuy = $.Url.QueryString("fastBuy");

        function activate() {
            GeneralService.getStateProvince().then(function (response) {
                vm.getStateProvince = response.data;
            });

            GeneralService.getCountry().then(function (response) {
                vm.getCountry = response.data;
            });

            GeneralService.getCountryOfSalesPoint().then(function (response) {
                if (response.data.length > 1) {
                    vm.getCountryOfSalesPoint = response.data;
                } else {
                    GeneralService.getStateProvinceOfSalesPointWithoutCountry().then(function (response) {
                        vm.getStateProvinceOfSalesPoint = response.data;
                    });
                }
            });

            GeneralService.getSalesPoints().then(function (response) {
                vm.getSalesPoint = response.data;
            });

            $scope.$watch("vm.pay.Total", function (value) {
                if (vm.cart && vm.salesOrderType === "direct") {
                    vm.cart.TotalWithDiscount = value || 0;
                }
            });

            $scope.$watch("vm.pay.CreditCardPaymentOption", function (value) {
                if (value) {
                    var valueArray = value.split("_");
                    if (valueArray.length > 1) {
                        vm.pay.Installment = valueArray[0];
                        vm.pay.BankId = valueArray[1];
                        vm.pay.InstallmentId = valueArray[2];
                    } else {
                        vm.pay.Installment = "00";
                        vm.pay.BankId = vm.DefaultCheckoutBank ? vm.DefaultCheckoutBank.Id : "";
                    }
                }
            });

            $scope.$watch("vm.pay.CardNumber", function (newValue, oldValue) {
                vm.pay.cartType = vm.getCreditCardType(newValue);
                vm.pay.cartMask = vm.getMaskType(vm.pay.cartType);
                if (newValue) {
                    var newbin = (newValue || "").replace(" ", "").substring(0, 6);
                    var oldbin = (oldValue || "").replace(" ", "").substring(0, 6);
                    if (newbin !== oldbin && newbin.length > 5) {
                        SalesPaymentService.getBanktype(newbin, vm.cart.TotalWithDiscount).then(function (data) {
                            vm.ActiveBank = data;
                            if (vm.ActiveBank.Bank) {
                                var oneInstallment = vm.ActiveBank.Bank.Installment.find(function (item) {
                                    return item.BankInstallment == 1;
                                });
                                vm.pay.CreditCardPaymentOption = "1_" + vm.ActiveBank.Bank.Id + (oneInstallment ? "_" + oneInstallment.Id : "");
                                vm.pay.ThreeDType = vm.ActiveBank.Bank.ThreeDType === null ? true : vm.ActiveBank.Bank.ThreeDType;
                            } else {
                                vm.pay.CreditCardPaymentOption = "1_" + vm.defaultCheckoutBank.Id;
                                vm.pay.ThreeDType = vm.defaultCheckoutBank.ThreeDType === null ? true : vm.defaultCheckoutBank.ThreeDType;
                            }
                        });
                    }
                }
            });
            $scope.$watch("vm.pay.BankId", function (newValue) {
                if (vm.banks) {
                    var bank = vm.banks.find(function (item) {
                        return item.Id === newValue;
                    });
                    vm.selectedBank = bank;
                    if (vm.cart && vm.cart.Id) {
                        vm.cart.SelectedBankId = vm.selectedBank.Id;
                        vm.updateCart();
                    }
                }
            });

            $scope.$watchCollection("[vm.deliveryAddress.Id,vm.billAddress.Id]", function (newValue, oldValue) {
                if (vm.cart) {
                    vm.cart.InvoiceAddressId = vm.billAddress != null ? vm.billAddress.Id : null;
                    vm.cart.DeliveryAddressId = vm.deliveryAddress != null ? vm.deliveryAddress.Id : null;
                    vm.updateCart();
                }
            });

            $scope.$watchCollection("[vm.cart.Id,vm.customerAddresses]", function (newValue, oldValue) {
                if (vm.cart && vm.customerAddresses) {
                    if (vm.cart.DeliveryAddressId) {
                        var selectedAdress = vm.customerAddresses.find(function (item) {
                            return item.Id == vm.cart.DeliveryAddressId;
                        });
                        vm.deliveryAddress = selectedAdress;
                    }
                    if (vm.cart.InvoiceAddressId) {
                        var selectedAdress = vm.customerAddresses.find(function (item) {
                            return item.Id == vm.cart.InvoiceAddressId;
                        });
                        vm.billAddress = selectedAdress;
                    } else if (vm.deliveryAddress) {
                        vm.billAddress = vm.deliveryAddress;
                    }
                }
            });

            $("#paymentModal").on("hidden.bs.modal", function (e) {
                $("#loading").attr("style", "display:flex !important");
                var url = window.location.href;
                if (url.contains("/Checkout/Checkout")) {
                    location.href = "/";
                } else {
                    location.href = url;
                }
            });

            $timeout(function () {
                if (vm.salesOrderType === "direct") {
                    vm.cart = {
                        TotalWithDiscount: 0.0,
                    };
                    vm.pay.Total = 0.0;
                    vm.tabIndex = 0;
                    window.scroll(0, 0);
                    vm.loading = false;
                    vm.getBanks();
                } else if (vm.salesOrderType === "debt") {
                    vm.cart = {
                        TotalWithDiscount: generalVariable.debtTotal,
                    };
                    vm.pay.Total = generalVariable.debtTotal;
                    vm.pay.Description = generalVariable.debtDescription;
                    vm.tabIndex = 0;
                    window.scroll(0, 0);
                    vm.loading = false;
                    vm.getBanks();
                } else {
                    vm.getCustomerAddresses();
                    if (vm.isAuthenticated) {
                        if (fastBuy === "true") {
                            vm.tabIndex = 2;
                            window.scroll(0, 0);
                        } else {
                            vm.tabOneDisable = true;
                            vm.tabIndex = 1;
                            window.scroll(0, 0);
                            vm.loading = false;
                        }
                    }
                    var cartId = $.Url.QueryString("cartId", window.location.href);
                    CartService.getCart({
                        Id: cartId,
                    }).then(function (data) {
                        //console.log(data);
                        //$.Analytics.Checkout_Progress(data);
                        vm.cart = data;
                        vm.cart.SelectedBankId = null;
                        vm.getBanks();
                        $.Analytics.Checkout_Progress(data, 3);
                    });
                }
            });
        }

        vm.getBanks = function () {
            GeneralService.GetBanks().then(function (data) {
                vm.banks = data.data.filter(function (item) {
                    return item.Active === true;
                });
                vm.checkoutBanks = vm.banks.filter(function (item) {
                    return item.UseCheckout;
                });
                vm.otherBanks = vm.banks.filter(function (item) {
                    return !item.UseCheckout;
                });
                vm.transferEFTBanks = data.data.filter(function (item) {
                    return item.TransferEFT && item.UseCheckout;
                });
                vm.defaultCheckoutBank = vm.banks.find(function (item) {
                    return item.Default;
                });
                if (!vm.defaultCheckoutBank.UseCheckout) {
                    vm.accorionStatus["_creditcard"] = {
                        open: false,
                    };
                    vm.accorionStatus[vm.defaultCheckoutBank.Id] = {
                        open: true,
                    };
                }
                vm.pay.ThreeDType = vm.defaultCheckoutBank.ThreeDType === null ? true : vm.defaultCheckoutBank.ThreeDType;
                vm.pay.BankId = vm.defaultCheckoutBank.Id;
                vm.pay.CreditCardPaymentOption = "1_" + vm.defaultCheckoutBank.Id;
                var tickBank = data.data.filter(function (item) {
                    return item.NormalizeName === "Tick";
                });
                if (tickBank) {
                    CustomerGeneralService.getRemainingTickPrice().then(function (response) {
                        vm.remainingTickPrice = response.data;
                    });
                }
            });
        };

        vm.checkout = function () {
            vm.loading = true;
            var formData = $('[name="vm.frmPayment"]').serialize();
            SalesPaymentService.payment(formData).then(function (data) {
                vm.loading = false;
                if (data.Content) {
                    var iframe = document.createElement("iframe");
                    var encodedUrl = encodeURI(data.Content);
                    encodedUrl = encodedUrl.replace(/#/g, "%23");
                    iframe.src = "data:text/html;charset=utf-8," + encodedUrl;
                    document.getElementById("paymentModalBody").appendChild(iframe);
                    $("#paymentModal").addClass(vm.selectedBank.NormalizedName).modal("show");
                } else if (data.Url) {
                    window.location.href = data.Url;
                } else {
                    alert("Ödeme Sırasında Hata Oluştu: " + data.ErrorMessage);
                }
            });
        };

        vm.selectBank = function (bank, customid) {
            if (customid) {
                vm.pay.BankId = vm.defaultCheckoutBank.Id;
                vm.accorionStatus[customid] = {
                    open: true,
                };
            } else {
                vm.pay.BankId = bank.Id;
                vm.accorionStatus[bank.Id] = {
                    open: true,
                };
                if (vm.accorionStatus["_creditcard"]) {
                    vm.accorionStatus["_creditcard"].open = false;
                }
            }
            $(".selectpicker").selectpicker();
        };

        vm.updateCart = function () {
            $(
                vm.cart.CartProduct.filter(function (element) {
                    return element.IsSpecificShipping == false;
                })
            ).each(function (i, item) {
                item.ShipmentProviderId = vm.cart.ShipmentProviderId;
                if (vm.cart.getCurrentShipmentProviderId != vm.cart.ShipmentProviderId) {
                    vm.VendorLocation.CountryId = null;
                    vm.VendorLocation.StateProvinceId = null;
                    vm.VendorLocation.DistrictId = null;
                    vm.cart.SalesPointId = null;
                    item.SalesPointId = null;
                } else {
                    item.SalesPointId = vm.cart.SalesPointId;
                }
            });

            $(
                vm.cart.CartProduct.filter(function (element) {
                    return element.IsSpecificShipping == true && !element.ShipmentProviderId;
                })
            ).each(function (i, element) {
                var shipmentProvider = element.CalculatedShippingPrice.sort(function (a, b) {
                    return a.Price - b.Price;
                });
                if (shipmentProvider && shipmentProvider.length > 0) {
                    element.ShipmentProviderId = shipmentProvider[0].ShipmentProvider.Id;
                }
            });
            CartService.updateCart(vm.cart).then(function (data) {
                vm.cart = data;

                vm.cart.getCurrentShipmentProvider = vm.cart.CalculatedShippingPrice.find(function (item) {
                    return item.ShipmentProvider.NormalizedName === "bayiden-teslimat";
                });
                if (vm.cart.getCurrentShipmentProvider) {
                    vm.cart.getCurrentShipmentProviderId = vm.cart.getCurrentShipmentProvider.ShipmentProvider.Id;
                }

                vm.getCurrentShipmentProvider(vm.cart.ShipmentProviderId);
            });
        };

        vm.getCurrentShipmentProvider = function (ShipmentProviderId) {
            if (ShipmentProviderId) {
                GeneralService.getCurrentShipmentProvider(ShipmentProviderId).then(function (response) {
                    if (response) {
                        vm.cart.getCurrentShipmentProviderName = response.data.NormalizedName;
                    }
                });
            }
        };

        vm.getCustomerAddresses = function () {
            vm.loading = true;
            CustomerAddressService.getCustomerAddresses().then(function (response) {
                if (response && response.length > 0) {
                    if (fastBuy == "true") {
                        //console.log("vm.cart", vm.cart);
                        vm.deliveryAddress = response[0];
                        vm.billAddress = response[0];
                        vm.tabIndex = 2;
                    } else {
                        vm.tabIndex = 1;
                    }
                    vm.customerAddresses = response;
                    vm.newGuestCustomerAddress = response[0];
                    vm.customer = response.Customer;
                    vm.tabOneDisable = true;
                    if (vm.newGuestCustomerAddress.StateProvinceId) {
                        vm.getStateProvinceChange(vm.newGuestCustomerAddress.StateProvinceId);
                    }
                } else {
                    if (vm.isAuthenticated) {
                        vm.customerAddresses = [];
                        vm.tabIndex = 1;
                        vm.newAddress = true;
                    } else {
                        vm.customerAddresses = [];
                        vm.tabIndex = 0;
                    }
                }
                vm.loading = false;
            });
        };

        vm.goPaymentTab = function () {
            if (vm.isAuthenticated) {
                vm.tabIndex = 2;
                window.scroll(0, 0);
            } else {
                vm.saveGuestUserAddress();
            }
        };

        vm.goAddressTab = function () {
            vm.tabIndex = 1;
            window.scroll(0, 0);
        };

        vm.saveGuestEmail = function () {
            if (vm.frmGuestUserEmail.$valid) {
                vm.loading = true;
                CustomerAddressService.addCustomerAddressWithUser(vm.newGuestCustomerAddress).then(
                    function (address) {
                        vm.newGuestCustomerAddress = address;
                        vm.tabOneDisable = true;
                        vm.tabIndex = 1;
                        window.scroll(0, 0);
                        vm.loading = false;
                    },
                    function (response) {
                        vm.loading = false;
                        vm.saveGuestEmailMessage = response.data.Message;
                    }
                );
            }
        };

        activate();

        vm.getCountryPointChange = function (CountryId) {
            if (CountryId) {
                GeneralService.getStateProvinceOfSalesPoint(CountryId).then(function (response) {
                    vm.cart.SalesPointId = null;
                    vm.getStateProvinceOfSalesPoint = response.data;
                });
            }
        };

        vm.getStateProvincePointChange = function (StateProvinceId) {
            if (StateProvinceId) {
                GeneralService.getDistrictOfSalesPoint(StateProvinceId).then(function (response) {
                    vm.cart.SalesPointId = null;
                    vm.getDistrictOfSalesPoint = response.data;
                });
            }
        };

        vm.getDistrictPointChange = function (DistrictId) {
            if (DistrictId) {
                GeneralService.getSalesPointsWithParameter(DistrictId).then(function (response) {
                    vm.getSalesPoint = response.data;
                });
            }
        };

        vm.getStateProvinceChange = function (StateProvinceId) {
            if (StateProvinceId) {
                GeneralService.getDistrict(StateProvinceId).then(function (response) {
                    vm.getDistrict = response.data;
                });
            }
        };

        vm.saveUserAddress = function () {
            if (vm.frmUserAddressSave.$valid) {
                $(".modal").modal("hide");
                CustomerAddressService.addCustomerAddress(vm.newCustomerAddress).then(function (response) {
                    //console.log("response", response.data);
                    vm.newAddress = false;
                    vm.newCustomerAddress = {};
                    vm.sec(response.data);
                    vm.getCustomerAddresses();
                });
            }
        };

        vm.saveGuestUserAddress = function () {
            vm.loading = true;
            if (vm.frmGuestUserAddressSave.$valid) {
                CustomerAddressService.addCustomerAddressWithUser(vm.newGuestCustomerAddress).then(
                    function (address) {
                        vm.deliveryAddress = address;
                        vm.billAddress = address;
                        vm.tabIndex = 2;
                        window.scroll(0, 0);
                        vm.loading = false;
                    },
                    function (response) {
                        vm.loading = false;
                        vm.saveGuestEmailMessageStep2 = response.data.Message;
                    }
                );
            }
        };

        vm.sec = function (delAddress) {
           // console.log("vm.checked :>> ", vm.checked);
            vm.deliveryAddress = delAddress;
            vm.cart.DeliveryAddressId = delAddress.Id;
            if (vm.checked) {
                vm.billAddress = delAddress;
                vm.cart.InvoiceAddressId = delAddress.Id;
            }
        };

        vm.billSec = function (bilAddress) {
            vm.billAddress = bilAddress;
            vm.cart.InvoiceAddressId = bilAddress.Id;
        };

        vm.billdel = function () {
            if (vm.checked) {
                vm.billAddress = vm.deliveryAddress;
                vm.cart.InvoiceAddressId = vm.cart.DeliveryAddressId;
            }
        };

        vm.prepareEdit = function (index) {
            vm.editAddress = true;
            vm.editAddressIndex = index;
            vm.getStateProvinceChange(vm.customerAddresses[vm.editAddressIndex].StateProvinceId);
        };

        vm.editUserAddress = function (editAddressIndex) {
            vm.loading = true;
            if (vm.frmUserAddressEdit.$valid) {
                $(".modal").modal("hide");
                CustomerAddressService.editCustomerAddress(vm.customerAddresses[editAddressIndex]).then(function () {
                    vm.editAddress = false;
                    vm.newAddress = false;
                    vm.editAddressIndex = null;
                    vm.getCustomerAddresses();
                });
            }
        };

        vm.deleteUserAddress = function (index) {
            if (confirm("Silmek istediğinize emin misiniz?")) {
                vm.loading = true;
                CustomerAddressService.deleteCustomerAddress(vm.customerAddresses[index]).then(function (response) {
                    vm.getCustomerAddresses();
                    vm.loading = false;
                });
            }
        };

        //// Utils  ///////////////

        vm.getMaskType = function (cardType) {
            var masks = {
                mastercard: "9999 9999 9999 9999",
                visa: "9999 9999 9999 9999",
                amex: "9999 999999 99999",
                diners: "9999 9999 9999 99",
                discover: "9999 9999 9999 9999",
                unknown: "9999 9999 9999 9999",
            };
            return masks[cardType];
        };

        vm.getCreditCardType = function (creditCardNumber) {
            // start without knowing the credit card type
            var result = "unknown";

            // first check for MasterCard
            if (/^5[1-5]/.test(creditCardNumber)) {
                result = "mastercard";
            }
            // then check for Visa
            else if (/^4/.test(creditCardNumber)) {
                result = "visa";
            }
            // then check for AmEx
            else if (/^3[47]/.test(creditCardNumber)) {
                result = "amex";
            }
            // then check for Diners
            else if (/3(?:0[0-5]|[68][0-9])[0-9]{11}/.test(creditCardNumber)) {
                result = "diners";
            }
            // then check for Discover
            else if (/6(?:011|5[0-9]{2})[0-9]{12}/.test(creditCardNumber)) {
                result = "discover";
            }

            return result;
        };

        vm.getFraction = function (x) {
            return (x - Math.floor(x)).toFixed(2).replace("0.", "");
        };

        vm.getDecimal = function (x) {
            return Math.floor(x);
        };

        vm.getInstallmentWithBankInstallment = function (installmentList, bankInstallment) {
            return installmentList.find(function (x) {
                return x.BankInstallment == bankInstallment;
            });
        };

        vm.getTotalInstallmentAverageDay = function (bank) {
            var dd = vm.pay.Total / vm.general.AmountPassedByCreditCard;
            var total = 0;
            for (let i = 2; i < bank.Installment.length; i++) {
                const item = bank.Installment[i];
                total += dd * bank.CollectionDaysInstallmentFirstPaymentDay + bank.CollectionDaysInstallmentRepaymentPeriod * (i - 1);
            }
            return total / vm.pay.Total;
        };

        vm.getMainImage = function (product) {
            var mainMedia =
                product.ProductMedia.find(function (media) {
                    return media.IsMain === true;
                }) || product.ProductMedia[0];
            if (mainMedia) {
                return mainMedia.Media.FullPath;
            } else {
                return "no-image.png";
            }
        };

        vm.IsAllProductInStock = function () {
            if (!vm.cart) {
                return false;
            }
            return !vm.cart.CartProduct.some(function (item) {
                return item.Product.TrackStockQuantity && item.Product.ClosedForSaleIfOutOfStock && item.Product.StockQuantity < item.Quantity;
            });
        };
    }
})();
